import { MbscEventCreatedEvent } from '@mobiscroll/react';

import { useFeature } from 'src/app/FeatureToggle';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { usePayers } from 'src/features/add-trip/Pricing/usePayers';

import { getExistingMultiloadTripIdsForAssignment } from '../../common/getExistingMultiloadTripIdsForAssignment';
import { getPotentialMultiloadCandidatesForUnassignedTrip } from '../../common/getPotentialMultiloadCandidatesForUnassignedTrip';
import { dispatcherSlice } from '../../dispatcher.slice';
import { useTripMenuActions } from '../useTripMenuActions';

export function useOnEventCreated() {
  const dispatch = useAppDispatch();
  const menuActions = useTripMenuActions();
  const assignedTrips = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.assigned_trips
  );
  const { payers } = usePayers();
  const { isEnabled: multiloadClosestFit } = useFeature(
    'multiload closest fit'
  );

  return async (newEvent: MbscEventCreatedEvent) => {
    const { hasPotentialMultiloadTripsAssigned, potentialMultiloadTripIds } =
      getPotentialMultiloadCandidatesForUnassignedTrip(
        newEvent.event.resource as string,
        newEvent.event.trip,
        assignedTrips,
        payers?.results
      );

    const assignmentId = newEvent.event.resource as string;
    let handled = false;

    if (
      hasPotentialMultiloadTripsAssigned &&
      potentialMultiloadTripIds.length > 0
    ) {
      if (multiloadClosestFit) {
        const existingMultiloadTripIds =
          getExistingMultiloadTripIdsForAssignment(
            potentialMultiloadTripIds,
            assignedTrips,
            newEvent.event.trip,
            multiloadClosestFit,
            assignmentId
          );

        if (existingMultiloadTripIds.length > 0) {
          menuActions.assignToExistingMultiLoad(
            newEvent.event.trip.id,
            assignmentId,
            existingMultiloadTripIds
          );
          handled = true;
        }
      }

      if (!handled) {
        const nonMultiloadedTripIds = potentialMultiloadTripIds.filter(
          (id) =>
            assignedTrips?.find((t) => t.id === id)?.multiload_id == null
        );
        if (nonMultiloadedTripIds.length > 0) {
          menuActions.multiloadAssign(
            newEvent.event.trip.id,
            assignmentId,
            nonMultiloadedTripIds
          );
          handled = true;
        }
      }
    }

    if (!handled) {
      await menuActions.assign(
        newEvent.event.trip.id,
        assignmentId,
        newEvent.event.trip.status
      );
    }
    dispatch(dispatcherSlice.actions.onCalendarEventDragEnd());
  };
}
